import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CampaignModel } from '../models/CampaignModel';
import { Globals } from '../models/Globals';
import { UdfControlType } from '../models/UdfControlType';
import { RequestModel } from '../models/RequestModel';

@Injectable({
    providedIn: 'root'
})
export class CampaignService {

    constructor(private http: HttpClient, private globals: Globals) { }

    getCampaign1(campaignId: number): Observable<CampaignModel | HttpResponse<CampaignModel>> {
        const url = `${this.globals.baseApiUrl}Campaign/${campaignId}`;
        return this.http
            .get<CampaignModel>(url)
            .pipe(
                tap(response => response),
                catchError(e => this.handleError(e))
            );
    }

    getCampaign(campaignId: number): Observable<CampaignModel | HttpResponse<CampaignModel>> {
        const url = `${this.globals.baseApiUrl}Campaign/${campaignId}`;
        return this.http
            .get<CampaignModel>(url)
            .pipe(
                tap(response => this.onGetCampaign(response)),
                catchError(e => this.handleError(e))
            );
    }


    onGetCampaign(campaign: CampaignModel): CampaignModel {
        campaign.isNew = false;
        this.globals.key = campaign.bi;
        for (const tree of campaign.trees) {
            tree.qty1 = 0;
            tree.qty2 = 0;
            tree.qty3 = 0;
            tree.qty4 = 0;
        }
        for (const udf of campaign.udf3) {
            udf.value = udf.uDFIControlType === UdfControlType.CheckBox ? false : '';
        }
        for (const tree of campaign.displayNotAvail) {
            tree.isSelected = false;
        }

        return campaign;
    }

    placeOrder(model: RequestModel) {
        const url = `${this.globals.baseApiUrl}Campaign/PlaceOrder`;
        return this.http
            .post<RequestModel>(url, model)
            .pipe(
                // tap(responce => {
                //     model.requestId = responce.requestId;
                //     model.isNew = false;
                // }), // this.onGetPlaceOrders(response),
                catchError(this.handleError2)
            );
    }

    private handleError = (error: HttpErrorResponse) => {
        var message = '';
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', this.getMessage(error.error));
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            message = error.status + ' ' + error.statusText;
            if (error.error && this.getMessage(error.error)) {
                message += '\r' + this.getMessage(error.error);
            }

            if (this.getMessage(error)) {
                message += '\r' + this.getMessage(error)
            }
            // console.error(
            //   `Backend returned code ${error.status}, ` +
            //   `body was: ${error.error}`);
            // alert(message);
        }
        // return an observable with a user-facing error message
        return throwError(message);
    }

    private handleError2 = (error: HttpErrorResponse) => {
        var message = '';
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', this.getMessage(error.error));
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            message = error.status + ' ' + error.statusText;
            if (error.error && this.getMessage(error.error)) {
                message += '\r' + this.getMessage(error.error);
            }

            if (this.getMessage(error)) {
                message += '\r' + this.getMessage(error)
            }
            // console.error(
            //   `Backend returned code ${error.status}, ` +
            //   `body was: ${error.error}`);
            alert(message);
        }
        // return an observable with a user-facing error message
        return throwError(message);
    }

    private getMessage(error: any): string {
        return error.Message;
    }
}
